<template>
  <div class="register-tab text-size-14">
    <template v-if="!completed">
      <div class="register-intro px-2 py-3">
        {{ $t('login.intro') }}
      </div>

      <div class="p-2">
        <InputTextValidated
          :label="$t('register.lblName')"
          type="text"
          v-model="form.name"
        />
        <span class="text-danger" v-if="errors.name">
          {{ errors.name[0] }}
        </span>
      </div>

      <div class="p-2">
        <InputTextValidated
          type="email"
          :label="$t('login.lblEmail')"
          v-model="form.email"
        />
        <span class="text-danger" v-if="errors.email">
          {{ errors.email[0] }}
        </span>
      </div>
      <div class="p-0 px-2 pt-2">
        <InputTextValidated
          :label="$t('login.lblPassword')"
          type="password"
          v-model="form.password"
        />
        <span class="text-danger" v-if="errors.password">
          {{ errors.password[0] }}
        </span>
      </div>

      <div class="terms-condition ml-2 mt-2" v-html="$t('general.termCondition')">
      </div>

      <div class="p-2 mt-2">
        <Btn
          :label="$t('register.register')"
          :loading="loading"
          @click.native="onRegister"
          full-width
        />
      </div>
      <LoginGoogle />
    </template>
    <template v-if="completed">
      <div class="p-2 mt-3 text-center">
        {{ $t('register.successHeader') }}
      </div>

      <div class="m-2 text-center p-2 bg-primary text-white rounded">
        {{ $t('register.successIntro') }}
      </div>

      <div class="p-2 text-center text-size-12">
        {{ $t('register.successIntro1') }}
      </div>

      <div class="p-2 text-center text-size-14 text-weight-semi-bold mb-3">
        {{ $t('register.successIntro2') }}
      </div>
    </template>
  </div>
</template>

<script>
import { formValidationMixin } from '@/components/mixins/FormValidationMixin.js';
import LoginGoogle from '@/components/Login/LoginGoogle';

export default {
  name: 'LoginTab',
  mixins: [formValidationMixin],

  data() {
    return {
      completed: false,
      loading: false,
      form: {
        name: null,
        email: null,
        password: null,
        locale: null,
      },
    };
  },

  components: {
    LoginGoogle,
  },

  methods: {
    onRegister() {
      // add the current locale to the user credentials
      this.form.locale = this.$i18n.locale;
      console.log('Register user:', this.form);

      this.clearErrors();

      this.form.email = this.form.email.trim();
      this.form.password = this.form.password.trim();      

      if (!this.isValidEmail()) return;
      if (!this.isValidName()) return;
      if (!this.isValidPassword()) return;

      this.loading = true;
      this.$store
        .dispatch('register', this.form)
        .then((response) => {
          this.loading = false;
          console.log('Register data :', response.data);
          this.completed = true;
        })
        .catch((error) => {
          this.loading = false;
          console.log('Registration error:', error);
          this.translatesBackendErrors(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';
.terms-condition {
  font-size: $very-small;
}

::v-deep .terms-condition a {
  cursor: pointer;
}
</style>
